import LaporanPurchaseOrder from './LaporanPurchaseOrder';

export default LaporanPurchaseOrder;
